// Reduced-motion override — parameter override, no separate code path.
// The plan called for `mosh_intensity *= 0.1`, `scanline_density = 0`,
// `agitation *= 0.2`. Same renderer, same shader; aggressive becomes calm
// without becoming "disabled".

import type { Parameters } from '../lib/parameters-schema';

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function applyReducedMotion(params: Parameters): Parameters {
  if (!prefersReducedMotion()) return params;
  return {
    ...params,
    mosh_intensity: params.mosh_intensity * 0.1,
    scanline_density: 0,
    agitation: params.agitation * 0.2,
  };
}

export function watchMotionPreference(onChange: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const handler = (): void => onChange();
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
